import { useEffect } from 'react';
import { useAppSelector } from '@store';
import {
  useLazyGetProductsIndividualQuery,
  useGetProductsValidatorsQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import ProductsList from '../../partial/products/list';

const IndividualClientsProductsList = (): React.JSX.Element => {
  const {
    individualClientsRisk: {
      products: {
        list: { values, pagination, errorsList },
      },
    },
  } = useAppSelector((state) => state);

  useGetProductsValidatorsQuery();

  const [getProducts, { isLoading, isFetching }] =
    useLazyGetProductsIndividualQuery();

  useEffect(() => {
    let title = 'Individual Products risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <ProductsList
      list={values}
      pagination={pagination}
      getList={getProducts}
      isFetching={isFetching}
      clientType={RiskScoreClientTypeEnum.INDIVIDUAL}
      isLoading={isLoading}
      errorsList={errorsList}
    />
  );
};

export default IndividualClientsProductsList;
